import { render, staticRenderFns } from "./driver_manager_dashboard.vue?vue&type=template&id=487ef47e&scoped=true&"
import script from "./driver_manager_dashboard.vue?vue&type=script&lang=js&"
export * from "./driver_manager_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./driver_manager_dashboard.vue?vue&type=style&index=0&id=487ef47e&scoped=true&lang=css&"
import style1 from "./driver_manager_dashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ef47e",
  null
  
)

export default component.exports